'use strict';

var $    									= require('jquery');
var Core 									= require('../core/core.js');
var Velocity    					= require('velocity-animate');
var InspectorColorPicker 	= require('./inspector__colorpicker.js');
var InspectorImage = require('./inspector__image.js');

/**
 * Creates an inspector button
 *
 * @class
 */

class InspectorModalBox extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
	      <div class='editor__inspector__modalbox js-inspector__modalbox'>
	        <div class='editor__inspector__modalbox__items js-inspector__modalbox__items'></div>
	      </div>
		`;

		super.render();

		// hide at first
		this.$el.hide();

	}

	/**
	* Visually show the modalbox
	* @param {Function} completeCallBack - optional function that gets called on complete
	*/
	show(completeCallBack){
		// this.$el.css('pointer-events', 'auto');
        this.$el.show();
		var self = this;

		Velocity(this.$el, "stop");
		Velocity(this.$el, {
				'opacity': 1.0
		}, 220, function () {
				$("body").on("click", function(e) {
					if (!self.$el.is(e.target) && self.$el.has(e.target).length === 0) {
						self.hide();
						$("body").off("click");
					}
				});

				if (typeof completeCallBack === 'function') {
						completeCallBack();
				}
		});
	}

	/**
	* Visually hide the modalbox
	*/
	hide(){
		var self = this;

		Velocity(this.$el, "stop");
		Velocity(this.$el, {
				'opacity': 0
		}, 220, function () {
				// self.$el.css('pointer-events', 'none'); // much less expensive call then show/hide
                self.$el.hide();
		});

		$("body").off("click");
	}

	/**
	* Clears the modalbox groups
	*/
	clear(){
		$('.js-inspector__modalbox__items',this.$el).empty();
	}

	/**
	* Sets position of modalbox
	*/
	setPosition(top, left){
		$(this.$el).css({
			'top': top+'px',
			'left': left+'px',
		});
	}

	addColorPicker() {
		return new InspectorColorPicker({
			target: $('.js-inspector__modalbox__items', this.$el)
		});
	}

	addImage(title, icon) {
		return new InspectorImage({
			target: $('.js-inspector__modalbox__items', this.$el),
			fields: {
				'title': title,
				'value': icon
			}
		});
	}
}
module.exports = InspectorModalBox;
